import { useState } from "react";
import { faqs } from "@/mocks/anime";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="补番前，你想问的小虎都有答案"
          desc="关于片单怎么选、评分怎么算、资源怎么找，这里一次性说清楚。还有别的疑问？欢迎到订阅表单里留言。"
        />

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-base text-foreground-950">{f.q}</span>
                  <span
                    className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg`} />
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-100 px-4 py-4 md:px-5">
                    <p className="text-sm leading-6 text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}